import { createRouter, createWebHistory } from 'vue-router'
import DialerPage from '../views/DialerPage'


const routes = [
  {
    path: "/",
    redirect: "/dialer"
  },
  {
    path: '/dialer',
    name: 'Dialer',
    component: DialerPage,
    redirect: '/dialer/register',
    children:[
      {
        path: "register",
				name: "register",
        component:()=>import('../components/forms/dialerForm/DialerRegister.vue')
      },
      {
        path: "upload",
				name: "upload",
        component:()=>import('../components/forms/dialerForm/DialerUpload.vue')
      },
      {
        path: "payment",
				name: "payment",
        component:()=>import('../components/forms/dialerForm/DialerPayment.vue')
      }

    ]
  },
  {
		path: "/returnPage",
		name: "returnPage",
		component: () => import("../views/ReturnPage.vue")
	},
  {
    path: "/thankPage",
		name: "thankPage",
		component: () => import("../views/ThankYouPage.vue")
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
